<template>
    <div class="userlist__item-button">
        <svg class="icon"
            @click="openCall(user.id, user.last_name, user.first_name, user.small_image, true)">
            <use xlink:href="/images/svg/symbols.svg#svg-user-phone"></use>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'opentok-call-btn',
    props: {
        user: {
            required: true,
        },
        type: {
            required: true,
        },
    },
    methods: {
        openCall(id, firstName, lastName, photo, isAudioCall) {
            const user = {
                fullName: `${firstName} ${lastName}`,
                photo,
                id,
                type: this.type,
                isAnswer: false,
                isAudioCall,
            }
            this.$store.dispatch('showCallModal', user)
        },
    },
}
</script>
